/**
 * IframeInnerLayer
 * Iframe을 내용으로 가지는 레이어 컴포넌트
 */
export default class IframeInnerLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_iframeInnerLayer';

    if (TMON.view_mode !== 'app') {
      // 레이어 중복 생성 방지
      if ($(`#${this.sWrapper}`).length < 1) {
        this.render();
      }
    }
  }

  render = () => {
    const sHtml = `<section id="${this.sWrapper}" class="popup popup_layer popup_iframe">
                <header class="popup_header">
                    <h3 class="popup_header_title" data-role="layerTitle"></h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <div class="popup_iframe_wrap" data-role=iFrameWrapper> </div>
                    </article>
                </div>
            </section>`;

    this.welContainer.append(sHtml);
  };

  /**
   * 레이어 열기 함수
   * @param {object} htParams
   *  {{
   *      {boolean} bHideTitle 타이틀 영역 생성할지 말지
   *      {string} title 타이틀 텍스트
   *      {string} src iframe의 target src (full url 절대경로여야 함)
   *  }}
   */
  open = htParams => {
    let sTitle = '티몬';
    if (htParams.title) {
      sTitle = htParams.title;
    }
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: false,
      });
      this.setInner(htParams);
      TMON.oApp.oUtil.setPositioningCenterOnPc(
        TMON.oApp.htStorage.htLastOpenLayer.welLastOpenLayer
      );
    } else if (TMON.oApp.sPlatform === 'MA') {
      TMON.app.callApp(
        'webview',
        'showNaviWebView',
        sTitle,
        TMON.util.aup(htParams.src, TMON.sAppQuery),
        false,
        false,
        true
      );
    } else {
      this.setInner(htParams);
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };

  setInner = htParams => {
    $(`#${this.sWrapper}`)
      .find('[data-role=iFrameWrapper]')
      .html(`<iframe src="${htParams.src}" frameborder="0"></iframe>`);
  };
}
